import { render, staticRenderFns } from "./StatUpdateCost.vue?vue&type=template&id=ebedda14&"
import script from "./StatUpdateCost.vue?vue&type=script&lang=js&"
export * from "./StatUpdateCost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports